import { useAppConfiguration } from "@domain/AppConfiguration"
import { computed } from "vue";

export const isDarkMode = computed( () =>
{
    const appConfiguration = useAppConfiguration();
    return appConfiguration.isDarkMode;
} );